<script setup>
import { computed } from 'vue';

const props = defineProps({
  appearance: {
    type: Object,
    required: true,
  },
});

const bubbleTextStyle = computed(() => ({
  fontSize: props.appearance?.fontSize,
  lineHeight: '1.4',
}));

const userBubbleStyle = computed(() => ({
  ...props.appearance?.userBubbleStyle,
  fontSize: props.appearance?.fontSize,
}));

const agentBubbleStyle = computed(() => ({
  ...props.appearance?.agentBubbleStyle,
  fontSize: props.appearance?.fontSize,
}));

const userTextStyle = computed(() => ({
  ...bubbleTextStyle.value,
  color: props.appearance?.userBubbleStyle?.color,
}));

const agentTextStyle = computed(() => ({
  ...bubbleTextStyle.value,
  color: props.appearance?.agentBubbleStyle?.color,
}));
</script>

<template>
  <div
    class="h-[calc(2rem*10)] px-4 overflow-y-auto"
    :style="{ fontSize: appearance?.fontSize }"
  >
    <div>
      <div>
        <div
          class="items-end flex justify-end ml-auto mb-1 mt-0 max-w-[85%] text-right"
        >
          <div
            class="rounded-[1.25rem] rounded-br-[0.25rem] px-4 py-3"
            :style="userBubbleStyle"
          >
            <p class="m-0" :style="userTextStyle">
              {{ $t('INBOX_MGMT.WIDGET_BUILDER.BODY.USER_MESSAGE') }}
            </p>
          </div>
        </div>
      </div>

      <div
        class="shadow rounded-[1.25rem] rounded-bl-[0.25rem] px-4 py-3 inline-block"
        :style="agentBubbleStyle"
      >
        <p class="m-0" :style="agentTextStyle">
          {{ $t('INBOX_MGMT.WIDGET_BUILDER.BODY.AGENT_MESSAGE') }}
        </p>
      </div>
    </div>
  </div>
</template>
